import { Box } from '#/components/Box/Box';
import { H4 } from '#/components/Text/H4';

type Props = {
  onClick: () => void;
  toggled: boolean;
  index: number;
  title: string;
};

export function CmsAccordionBlockTitle({
  onClick,
  toggled,
  index,
  title,
}: Props) {
  return (
    // oxlint-disable-next-line jsx-a11y/control-has-associated-label
    <button
      type="button"
      onClick={onClick}
      aria-controls={'accordionSection' + index}
      aria-expanded={toggled}
      style={{ width: '100%' }}
    >
      <H4 m="0" py="30px">
        <Box
          display="flex"
          justifyContent="space-between"
          width="100%"
          alignItems="center"
          textAlign="left"
        >
          <span>{title}</span>
          <span>{toggled ? '-' : '+'}</span>
        </Box>
      </H4>
    </button>
  );
}
